import { Component, OnInit, Input, ChangeDetectorRef, OnChanges, Output, EventEmitter } from '@angular/core';
import { PopupComponent } from '@app/components/popup/popup.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ApiService } from '../utilities/services/api.service';
import { BaseService } from '@app/system/services/base.service';
import { AssignmentUpdateComponent } from '../assignment-update/assignment-update.component';
import { LocaleService } from '@app/system/services/locale.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { ArrToStrPipe } from '@app/system/pipes/arr-to-str/arr-to-str.pipe';
import { OptionMenu } from '@app/layout/utilities/models/layout-model';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { CourseProgressComponent } from '@app/modules/course/course-progress/course-progress.component';

@Component({
	selector: 'app-assignment-info',
	templateUrl: './assignment-info.component.html',
	styleUrls: ['./assignment-info.component.scss']
})
export class AssignmentInfoComponent implements OnInit, OnChanges {

	@Input() resourceID;
	@Input() resourceData;
	@Input() assignmentID;
	@Input() actualAssignmentID;
	@Input() type: 'assign_to_me' | 'assign_by_me';
	@Input() viewType: 'info' | 'detail' | 'assignmentDetail';
	@Output() infoLoader = new EventEmitter<boolean>(true);
	@Output() assignmentEmit = new EventEmitter();

	currentUser;
	buttonDisable = false;
	popupRef;
	assignmentDetail;
	history = [];
	historyIndex = 0;
	optionMenu: Array<OptionMenu>;
	deviceDetails;

	constructor(
		private popup: MatDialog,
		private apiService: ApiService,
		private baseService: BaseService,
		public gfService: GlobalFunctionService,
		public locale: LocaleService,
		public detectDevice: DetectDeviceService,
		private cdref: ChangeDetectorRef,
		private arrToStr: ArrToStrPipe
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
		if (this.assignmentID) {
			this.popupRef.componentInstance.popupLoader = true;
			const headers = {};
			this.apiService.getAssignment(this.assignmentID, headers).subscribe(
				(response) => {
					if (response) {
						this.assignmentDetail = response;
						this.dataBuild(this.assignmentDetail, 'general');
						// this.assignmentDetail.workGroupAssignment = [
						// 	{
						// 		"assignmentID": 137,
						// 		"type": 1,
						// 		"assigner": {
						// 			"city": {
						// 				"ID": 19,
						// 				"name": "Chennai"
						// 			},
						// 			"userID": 33,
						// 			"company": {
						// 				"ID": null,
						// 				"name": null
						// 			},
						// 			"lastName": "Jagan",
						// 			"location": {
						// 				"ID": 20,
						// 				"name": "T Nagar"
						// 			},
						// 			"firstName": "Priya",
						// 			"department": {
						// 				"ID": 15,
						// 				"name": "Marketing"
						// 			},
						// 			"profilePic": "",
						// 			"designation": {
						// 				"ID": 171,
						// 				"name": "Manager - Marketingg"
						// 			},
						// 			"profilePicURL": "https://dev.unifilearning.com/uploads/db1ee53a-aa04-4492-b869-cc601b6b59de.jpg"
						// 		},
						// 		"assignee": {
						// 			"city": {
						// 				"ID": 19,
						// 				"name": "Chennai"
						// 			},
						// 			"userID": 37,
						// 			"company": {
						// 				"ID": null,
						// 				"name": null
						// 			},
						// 			"lastName": "Kapoor",
						// 			"location": {
						// 				"ID": 20,
						// 				"name": "T Nagar"
						// 			},
						// 			"firstName": "Sandeep",
						// 			"department": {
						// 				"ID": 15,
						// 				"name": "Marketing"
						// 			},
						// 			"profilePic": "",
						// 			"designation": {
						// 				"ID": 77,
						// 				"name": "Executive - Marketing"
						// 			},
						// 			"profilePicURL": "http://demo.unifilearning.com/uploads/profile_37_1600881595305.jpg"
						// 		},
						// 		"assignedDT": 1614854695484,
						// 		"assignerNotes": null,
						// 		"completeByTime": 1614882600000,
						// 		"completedTime": null,
						// 		"assigneeNotes": null,
						// 		"evalDT": null,
						// 		"score": null,
						// 		"evalNotes": null,
						// 		"reassignReference": null,
						// 		"status": 2,
						// 		"taskGroup": null,
						// 		"resourceTitle": "Node.js - Introduction",
						// 		"resourceTypeID": 3,
						// 		"resourceTypeName": "News",
						// 		"payloadResourceID": 376,
						// 		"seriesID": null,
						// 		"resourceThumbnail": "https://i.ytimg.com/vi/1IkcJcu4ksE/maxresdefault.jpg",
						// 		"resourceFormat": 5,
						// 		"completedPercent": null,
						// 		"workgroup": null,
						// 		"stats": {},
						// 		"assignmentReference": null
						// 	}
						// ];
						if (this.assignmentDetail && this.assignmentDetail.workGroupAssignment && this.assignmentDetail.workGroupAssignment.length) {
							for (const data of this.assignmentDetail.workGroupAssignment) {
								this.dataBuild(data, 'workgroupAssignment');
							}
						}
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.popupRef.componentInstance.popupLoader = false;
				});
		}
	}

	ngOnChanges(changes) {
		if (changes.resourceID && changes.resourceID.currentValue) {
			if (this.type === 'assign_by_me') {
				const headers = {};
				this.assignmentDetail = null;
				this.apiService.getResourceByMe(changes.resourceID.currentValue, headers).subscribe(
					(response) => {
						if (response && Array.isArray(response.records)) {
							// this.gfService.resourceDetailScroll = false;
							if (this.actualAssignmentID) {
								this.assignmentDetail = response.records.find(items => items.assignmentID === this.actualAssignmentID);
							} else {
								this.assignmentDetail = response['records'].sort(
									(a, b) => (a.assignedDT > b.assignedDT ? 1 : -1)
								)[0];
							}
							if (this.assignmentDetail) {
								this.dataBuild(this.assignmentDetail, 'general');
								if (this.assignmentDetail && this.assignmentDetail.workGroupAssignment && this.assignmentDetail.workGroupAssignment.length) {
									for (const data of this.assignmentDetail.workGroupAssignment) {
										this.dataBuild(data, 'workgroupAssignment');
									}
								}
							}
						}
						this.assignmentEmit.emit(this.assignmentDetail);
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
						this.assignmentEmit.emit(null);
					}
				)
					.add(() => {
						this.infoLoader.emit(false);
					});
			} else if (this.type === 'assign_to_me') {
				const headers = {};
				this.assignmentDetail = null;
				this.apiService.getResourceForMe(changes.resourceID.currentValue, headers).subscribe(
					(response) => {
						if (response && Array.isArray(response.records)) {
							// this.gfService.resourceDetailScroll = false;
							if (this.actualAssignmentID) {
								this.assignmentDetail = response.records.find(items => items.assignmentID === this.actualAssignmentID);
							} else {
								this.assignmentDetail = response['records'].sort(
									(a, b) => (a.assignedDT > b.assignedDT ? 1 : -1)
								)[0];
							}
							if (this.assignmentDetail) {
								let assignersName = [];
								let assignerData = [];
								response.records.map((resp) => {
									if (resp.assigner) {
										let options = {
											value: `${resp.assigner.firstName}${resp.assigner.lastName
												? ' ' + resp.assigner.lastName
												: ''}`,
											key: resp.assigner.userID
										};
										assignerData.push(options);
										assignersName.push(options.value);
									}
								});
								assignerData = this.gfService.getUniqueArray(assignerData, 'key');
								assignersName = this.gfService.removeDuplicateArr(assignersName);
								this.assignmentDetail.assigners = this.arrToStr.transform(assignersName);
								this.dataBuild(this.assignmentDetail, 'general');
							}
						}
						this.assignmentEmit.emit(this.assignmentDetail);
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
						this.assignmentEmit.emit(null);
					}
				)
					.add(() => {
						this.infoLoader.emit(false);
					});
			}
		}
	}

	searchPeopleDetail(data) {
		if (data && data.userID) {
			this.baseService.userDetail(data.userID);
		}
	}

	dataBuild(data, action: 'general' | 'workgroupAssignment') {
		data.status = this.baseService.referenceType(
			'assignmentStatus',
			data.status
		);
		data.type = this.baseService.referenceType(
			'assignmentType',
			data.type
		);
		if (data.status && ['assigned'].includes(data.status.key) && data.completeByTime && data.completeByTime < Date.now()) {
			data.status = this.baseService.referenceType(
				'assignmentStatus',
				6
			);
		}
		if (action === 'general' && ['detail', 'assignmentDetail'].includes(this.viewType) && data.status && !['closed', 'reassigned', 'aborted'].includes(data.status.key)) {
			if (data.assigner && data.assigner.userID === this.currentUser.userID) {
				this.optionMenu = [
					{
						caption: this.locale.translate('abort'),
						key: 'abort',
						classes: [],
						disabled: false
					}
				];
			}
		}
		data.completeByTime = this.gfService.dateFormat(
			data.completeByTime,
			'MMM d, y'
		);
		data.completedTime = this.gfService.dateFormat(
			data.completedTime,
			'MMM d, y'
		);
		data.assignedDT = this.gfService.dateFormat(
			data.assignedDT,
			'MMM d, y'
		);
		data.evalDT = this.gfService.dateFormat(
			data.evalDT,
			'MMM d, y'
		);

		if (data.assignee) {
			if (data.assignee.completedPercent) {
				data.progress = (data.assignee.completedPercent) ? data.assignee.completedPercent : 0;
			} else {
				data.progress = (data.completedPercent) ? data.completedPercent : 0;
			}
		} else {
			data.progress = (data.completedPercent) ? data.completedPercent : 0;
		}

		// data.progress = (data.completedPercent) ? data.completedPercent : 0;
		// data.workgroup = {
		// 	groupName: 'test'
		// };
		if (this.type === 'assign_by_me' && data.workgroup && Object.keys(data.workgroup).length) {
			if (data.assignee) {
				data.assignee.name = data.workgroup.groupName;
			}
		} else {
			if (data.assignee) {
				data.assignee.name = `${data.assignee.firstName}${data.assignee.lastName
					? ' ' + data.assignee.lastName
					: ''}`;
			}
		}
		if (data.assigner) {
			data.assigner.name = `${data.assigner.firstName}${data.assigner.lastName
				? ' ' + data.assigner.lastName
				: ''}`;
		}
	}

	assignmentInfo() {
		if (navigator.onLine) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: AssignmentInfoComponent,
					componentData: [
						{
							variableName: 'viewType',
							value: 'detail'
						},
						{
							variableName: 'type',
							value: this.type
						},
						{
							variableName: 'assignmentID',
							value: this.assignmentDetail.assignmentID
						},
						{
							variableName: 'resourceData',
							value: this.resourceData
						},
						{
							variableName: 'updateFromResource',
							value: false
						}
					]
				},
				disableClose: true,
				maxWidth: '860px',
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result) {
					if (typeof result === 'object') {
						const assigners = this.assignmentDetail.assigners;
						result.assigners = assigners;
						this.assignmentDetail = result;
						this.assignmentEmit.emit(this.assignmentDetail);
					}
				}
			});
		}
	}

	submit(action, event, data) {
		if (navigator.onLine) {
			if (this.viewType === 'detail') {
				this.popupRef.close(data);
			} else if (this.viewType === 'assignmentDetail') {
				this.popupRef.componentInstance.dialogCloseData = data;
			}
			if (action !== 'markAsRead') {
				this.updateStatus(action, event, data);
			} else if (this.resourceData && this.resourceData.read) {
				this.alertPopup(action, event);
			}
		}
	}

	optionInfo(option) {
		if (option.key === 'abort') {
			this.alertPopup('abort');
		}
	}

	alertPopup(action: string, event: any = null) {
		let title = '';
		let content = '';
		if (action === 'markAsRead') {
			title = this.locale.translate('mark_as_complete');
			content = this.locale.translate('mark_as_read_resource');
		} else if (action === 'abort') {
			title = this.locale.translate('abort');
			content = this.locale.translate('abort_resource');
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title,
				content,
				buttons: [
					{
						type: 'main-action',
						caption: this.locale.translate('yes'),
						key: 'yes'
					},
					{
						type: 'main-action',
						caption: this.locale.translate('no'),
						key: 'no',
						autoFocus: true
					}
				],
				triggerEl: event
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					if (action === 'markAsRead') {
						this.markAsRead();
					} else if (action === 'abort') {
						this.abort();
					}
				}
			}
		});
	}

	abort() {
		this.popupRef.componentInstance.popupLoader = true;
		const headers = {};
		this.apiService.abort({}, this.assignmentDetail.assignmentID, headers).subscribe(
			(response) => {
				this.assignmentDetail.status = this.baseService.assignmentStatus.find(items => items.key === 'aborted');
				if (this.assignmentDetail.workGroupAssignment && this.assignmentDetail.workGroupAssignment.length) {
					for (const data of this.assignmentDetail.workGroupAssignment) {
						data.status = this.baseService.assignmentStatus.find(items => items.key === 'aborted');
					}
				}
				this.popupRef.componentInstance.dialogCloseData = this.assignmentDetail;
				this.optionMenu = [];
				this.assignmentDetail.assignmentChanged = true;
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('assignment_aborted'),
					icon: 'check_circle_outline',
					position: 'before'
				});
				this.popupRef.close(this.assignmentDetail);
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
				// this.gfService.formErrorHandler(error, this.formObject.form);
			}
		)
			.add(() => {
				this.popupRef.componentInstance.popupLoader = false;
			});

	}

	markAsRead() {
		this.buttonDisable = true;
		const headers = {};
		const apiValue = {
			notificationType: 1
		};
		if (this.deviceDetails.browserName === 'Safari') {
			apiValue.notificationType = 2;
		}
		this.apiService.submit(apiValue, this.assignmentDetail.assignmentID, headers).subscribe(
			(response) => {
				this.assignmentDetail.status = this.baseService.referenceType('assignmentStatus', 4);
				this.assignmentDetail.assignmentChanged = true;
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('assignment_completed'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
				// this.gfService.formErrorHandler(error, this.formObject.form);
			}
		)
			.add(() => {
				this.buttonDisable = false;
			});

	}

	updateStatus(action, event, data) {
		if (this.viewType === 'assignmentDetail') {
			if (this.popupRef) {
				this.popupRef.close({ openResource: true, data });
			}
		} else {
			this.baseService.formView = true;
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: AssignmentUpdateComponent,
					componentData: [
						{
							variableName: 'action',
							value: action
						},
						{
							variableName: 'assignmentID',
							value: data.assignmentID
						},
						{
							variableName: 'resourceDetail',
							value: this.resourceData
						}
					],
					triggerEl: event
				},
				disableClose: true,
				maxWidth: '860px',
				autoFocus: true
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result && typeof result === 'object') {
					if (action === 'submit') {
						data.assignerNotes = null;
						data.status = this.baseService.referenceType('assignmentStatus', 2);
						data.assigneeNotes = result.assigneeNotes;
						data.completedTime = this.gfService.dateFormat(
							Date.now(),
							'MMM d, y'
						);
						data.assignmentChanged = true;
					} else if (action === 'reassign') {
						data.completedTime = null;
						data.assigneeNotes = null;
						data.reassignReference = data.assignmentID;
						data.status = this.baseService.referenceType('assignmentStatus', 3);
						data.assignerNotes = result.assignerNotes;
						data.completeByTime = this.gfService.dateFormat(result.completeByTime, 'MMM d, y');
						data.assignmentID = result.recordID;
						data.reAssignSVGIcon = 'reassign';
						data.assignmentChanged = true;
					} else if (action === 'evaluate') {
						data.status = this.baseService.referenceType('assignmentStatus', 4);
						data.evalNotes = result.evalNotes;
						data.score = result.score;
						data.assignmentChanged = true;
					}
					this.cdref.detectChanges();
				}
			});
		}
	}

	viewHistory() {
		if (navigator.onLine) {
			this.popupRef.componentInstance.loader = true;
			const headers = {};
			this.apiService.getHistory(this.assignmentDetail.assignmentID, headers).subscribe(
				(response) => {
					if (response && Array.isArray(response.records)) {
						for (const data of response.records) {
							this.dataBuild(data, 'general');
						}
						this.history = response.records;
						this.history.unshift(this.assignmentDetail);
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					this.popupRef.componentInstance.loader = false;
				});
		}
	}

	next() {
		if (navigator.onLine) {
			if (this.history.length !== this.historyIndex + 1) {
				this.historyIndex += 1;
				this.assignmentDetail = this.history[this.historyIndex];
			}
		}
	}

	prev() {
		if (navigator.onLine) {
			if (this.historyIndex !== 0) {
				this.historyIndex -= 1;
				this.assignmentDetail = this.history[this.historyIndex];
			}
		}
	}

	courseProgressDetail(data){
		let userData : any =  data.assignee;
		userData.completedPercent = data.progress;
		userData.date = this.gfService.dateFormat(data.enrolmentDate,
			'MMM d, y'
		);
		
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseProgressComponent,
				componentData: [
					{
						variableName: 'actualResourceID',
						value: data.payloadResourceID
					},
					{
						variableName: 'userData',
						value: userData
					},
					{
						variableName: 'progressData',
						value: data.progress
					}
				]
			},
			
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}
			
		});
	}

}
